var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuperReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0427 11.6914L14.7535 13.0437L16.2891 13.2865L15.1928 14.3651L15.431 15.8674L14.0427 15.1818L12.6543 15.8674L12.8925 14.3651L11.7963 13.2865L13.3318 13.0437L14.0427 11.6914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8243 8.20052L13.9623 6.47461L14.0087 6.55904L14.0546 6.47501L17.1062 8.14128H19.8894V9.31269L21.0211 10.5473L19.8894 12.2963V14.7429L19.8883 14.7639C19.8129 16.2454 19.314 17.5678 18.3228 18.7144C17.3451 19.8456 15.9242 20.765 14.0651 21.5251L14.0253 21.4278L13.9857 21.5247C12.1255 20.7641 10.7121 19.8439 9.74253 18.7109C8.75983 17.5626 8.27207 16.2407 8.19685 14.7634L8.19579 14.7425V12.2959L7.06409 10.5469L8.19579 9.31228V8.11292L10.8243 8.20052ZM14.0108 8.33104L16.6851 9.79128H18.2394V9.95451L18.9428 10.7219L18.2394 11.809V14.7002C18.1783 15.8263 17.8081 16.7868 17.0745 17.6354C16.4119 18.402 15.4252 19.1086 14.026 19.7454C12.6292 19.109 11.6509 18.4032 10.9961 17.6381C10.2712 16.791 9.90706 15.8301 9.84579 14.6998V11.8086L9.14236 10.7215L9.84579 9.9541V9.81882L11.2223 9.8647L14.0108 8.33104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95736 17.9928C8.27612 18.5935 8.68665 19.1527 9.18586 19.6729L8.08707 19.7791C7.02747 19.2927 6.35531 18.6684 6.13248 18.0855L7.95736 17.9928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15247 14.8014V14.9972L7.15399 15.0259C7.18876 15.6824 7.30156 16.3024 7.49014 16.8876L4.99669 16.9245C3.95525 16.4398 3.31713 15.6324 2.88481 14.8399L7.15247 14.8014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52391 11.4006L7.15247 12.3345V13.4962L2.23495 13.5497C1.37105 13.1689 0.451961 12.1823 0.0124512 11.3809L6.52391 11.4006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8141 19.6729C19.3134 19.1527 19.7239 18.5935 20.0426 17.9928L21.8675 18.0855C21.6447 18.6684 20.9725 19.2927 19.9129 19.7791L18.8141 19.6729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8475 14.8014L25.1152 14.8399C24.6829 15.6324 24.0447 16.4398 23.0033 16.9245L20.5099 16.8876C20.6984 16.3024 20.8112 15.6824 20.846 15.0259L20.8475 14.9972V14.8014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8475 12.3345L21.4761 11.4006L27.9875 11.3809C27.548 12.1823 26.6289 13.1689 25.765 13.5497L20.8475 13.4962V12.3345Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperReward);
export default __webpack_public_path__ + "static/media/super-reward.4d9f672e5817d4f82bb36735cd4ef050.svg";
export { ForwardRef as ReactComponent };